import React, {PureComponent} from 'react';
import {Comment, CommentToSend, Publication, User} from "../../api/types";
import PublicationFooter from "./PublicationFooter";
import paanteon from "../../api/paanteonRequests";
import Notification from "../../api/notification";
import {pictoCertification, pictoSharingBlack} from "../../api/pictos";
import ReportModal from "../ReportModal";
import localStorage from "../../api/localStorage";
import ConfirmModal from "../ConfirmModal";
import {injectUIRouter, Link} from "../../api/injectors";
import {UIRouterReact} from "@uirouter/react";
import OptionsMenu from "../OptionsMenu";
import {stopPropagation} from "../../api/helpers";
import {processLinks} from "../../api/domHelper";
import {CommentOpenable} from "./types";

type Props = Readonly<{
    children: React.ReactNode
    publication: Publication
    footer?: boolean
    onDelete?(publicationId: number, type: 0 | 1 | 2): any
    router: UIRouterReact
}> & CommentOpenable;

type State = {
    item: Publication
    showDeleteConfirm: boolean
}

class Share extends PureComponent<Props, State> {
    protected user: Readonly<User> = localStorage.getLocalUser();
    state = {
        item: this.props.publication,
        showDeleteConfirm: false,
    };

    toggleLike = () => {
        if (this.state.item.liked) {
            paanteon.unlike({publicationId: this.state.item.publicationId}).then(() => {
                this.setState(prevState => ({
                    ...prevState,
                    item: {
                        ...prevState.item,
                        liked: false,
                        likeCount: prevState.item.likeCount - 1,
                    },
                }));
            }, () => {
                Notification.error("Une erreur est survenue, veuillez réessayer plus tard");
            });
        } else {
            paanteon.like({publicationId: this.state.item.publicationId}).then(() => {
                this.setState(prevState => ({
                    ...prevState,
                    item: {
                        ...prevState.item,
                        liked: true,
                        likeCount: prevState.item.likeCount + 1,
                    },
                }))
            }, () => {
                Notification.error("Une erreur est survenue, veuillez réessayer plus tard");
            });
        }
    }

    onShare = () => {
        this.setState(prevState => ({
            ...prevState,
            item: {
                ...prevState.item,
                shareCount: prevState.item.shareCount + 1,
            },
        }));
    }

    sendComment = (comment: CommentToSend) => {
        const comm = {
            ...comment,
            publicationId: this.state.item.publicationId,
        };
        const answerId = comm.answerId;
        if (comm.answerId === -1) delete comm.answerId;
        return paanteon.comment(comm).then((res: {data: Comment}) => {
            this.setState(prevState => {
                if (!res.data.Answers) res.data.Answers = [];
                let nState = {
                    ...prevState,
                    item: {
                        ...prevState.item,
                        commented: 1 as 1,
                    },
                };
                if (answerId === -1) {
                    nState.item.Comments = [...nState.item.Comments, res.data];
                } else {
                    const comm = nState.item.Comments.find(comm => comm.commentId === answerId);
                    if (comm && comm.Answers) comm.Answers = [...comm.Answers, res.data];
                }
                return nState;
            });
            return true;
        }, function() {
            Notification.error("Erreur lors de la création du commentaire");
            return false;
        });
    };

    deleteComment = (commentId: number) => {
        return paanteon.deleteComment(commentId).then(() => {
            this.setState(prevState => ({
                ...prevState,
                item: {
                    ...prevState.item,
                    Comments: prevState.item.Comments.filter(c => c.commentId !== commentId).map(c => {
                        if (c.Answers) c.Answers = c.Answers.filter(a => a.commentId !== commentId);
                        return c;
                    }),
                },
            }));
            return true;
        });
    }

    openConfirmDelete = () => {
        this.setState(prevState => ({
            ...prevState,
            showDeleteConfirm: true,
        }));
    }

    closeConfirmDelete = () => {
        this.setState(prevState => ({
            ...prevState,
            showDeleteConfirm: false,
        }));
    }

    confirmDelete = () => {
        paanteon.deletePublication(this.props.publication.publicationId).then(() => {
            Notification.success("Publication supprimée avec succès");
            this.setState(prevState => ({
                ...prevState,
                showDeleteConfirm: false,
            }));
            if (this.props.onDelete) this.props.onDelete(this.props.publication.publicationId, 2);
        }, function() {
            Notification.error("Erreur lors de la suppression de la publication")
        })
    }

    goToPublication = (event: React.SyntheticEvent) => {
        event.stopPropagation();
        this.props.router.stateService.go('connected.inspiration-feed.publication', {publicationId: this.state.item.publicationId});
    }

    render() {
        if (this.state.item.content && this.state.item.content.length > 0)
            return <>
                <div className={"tile condensed sep clickable" + (this.props.footer ? ' parent' : '')} style={{position: 'relative'}} onClick={this.goToPublication}>
                    <OptionsMenu>
                        <span className="options-menu">
                            <ul>
                                <li>
                                    <ReportModal publicationId={this.props.publication.publicationId}>
                                        <button className="btn link-btn">Signaler</button>
                                    </ReportModal>
                                </li>
                                {
                                    (this.props.publication.userId === this.user.userId || this.user.admin) && <li>
                                        <button className="btn link-btn" onClick={this.openConfirmDelete}>Supprimer</button>
                                    </li>
                                }
                            </ul>
                        </span>
                    </OptionsMenu>

                    <div className="tile-body">
                        <div className="feed-item">
                            <div className="profile-pic"
                                 style={{backgroundImage: "url(" + this.state.item.User.picturePath + ')'}}/>
                            <div>
                                <span onClick={stopPropagation}>
                                    <em className="ptn-em">
                                        <Link to="connected.paanteon.user" params={{userId: this.state.item.userId, username: this.state.item.User.username}}>{this.state.item.User.firstname + ' ' + this.state.item.User.lastname}</Link>
                                        {
                                            this.state.item.User.certificationDate !== null && <img className="certification" src={pictoCertification} alt="certifié"/>
                                        }
                                    </em>
                                    <small className={"username"}>@{this.state.item.User.username}</small>
                                    &nbsp;a partagé :</span>
                                <p onClick={e => e.stopPropagation()}>{processLinks([this.state.item.content])}</p>
                                {this.props.children}

                                {
                                    this.props.footer && <PublicationFooter onDeleteComment={this.deleteComment}
                                                                            publication={this.state.item}
                                                                            onLike={this.toggleLike}
                                                                            onShare={this.onShare}
                                                                            onComment={this.sendComment}
                                                                            commentOpen={this.props.commentOpen}/>
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {
                    this.state.showDeleteConfirm && <ConfirmModal onCancel={this.closeConfirmDelete} onConfirm={this.confirmDelete}>Êtes-vous sûr(e) de vouloir supprimer définitivement cette publication ?</ConfirmModal>
                }
            </>
        else
            return <div className="tile condensed sep shared-feed">
                <div className="tile-body">
                    <div className="feed-notice">
                        <img alt="picto share" className="picto" src={pictoSharingBlack}/>
                        {this.state.item.User.firstname + ' ' + this.state.item.User.lastname} <small className={"username"}>@{this.state.item.User.username}</small> a partagé :
                    </div>
                    {this.props.children}
                </div>
            </div>
    }
}

export default injectUIRouter(Share);
